<template>
    <div id="global_notification" v-if="notifications.length">
        <div class="container notifications">
            <template v-for="(notification) in notifications">
            <div class="notifications-item"  :class="{'show': notification.isExpand}" v-if="deleteNotifications.indexOf(notification.item.id) === -1">
                <div class="notifications-item-image">
                    <img :src="'/storage' + notification.item.main_image.path" alt="" v-if="notification.item.main_image">
                    <template v-else>
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="12" fill="#EE7372"/>
                            <path d="M8.0851 6.94074L8.08509 6.94074C6.55892 8.11565 5.64783 9.96969 5.64783 11.9C5.64783 12.0931 5.4917 12.25 5.29891 12.25C5.10613 12.25 4.95 12.0931 4.95 11.9C4.95 9.75335 5.96301 7.69209 7.66031 6.3854L7.69082 6.42502L8.0851 6.94074ZM8.0851 6.94074L8.05471 6.90127L8.0851 6.94074Z" fill="white" stroke="white" stroke-width="0.1"/>
                            <path d="M15.6651 6.94074L15.6651 6.94074L16.0899 6.3854C15.937 6.26767 15.7178 6.29682 15.6006 6.45016C15.4834 6.60342 15.5123 6.82312 15.6651 6.94074Z" fill="white" stroke="white" stroke-width="0.1"/>
                            <path d="M6.79403 16.45H7.09294C7.2857 16.45 7.44186 16.2934 7.44186 16.1C7.44186 15.9066 7.2857 15.75 7.09294 15.75H6.79403C6.60128 15.75 6.44512 15.9066 6.44512 16.1C6.44512 16.2934 6.60128 16.45 6.79403 16.45Z" fill="white" stroke="white" stroke-width="0.1"/>
                            <path d="M5.57695 17C5.57695 17.6172 5.99351 18.25 6.79331 18.25C6.98606 18.25 7.14222 18.0934 7.14222 17.9C7.14222 17.7066 6.98606 17.55 6.79331 17.55C6.598 17.55 6.4708 17.4756 6.39115 17.3731C6.31001 17.2687 6.27478 17.1305 6.27478 17C6.27478 16.8695 6.31001 16.7312 6.39115 16.6268C6.4708 16.5243 6.598 16.45 6.79331 16.45C6.98606 16.45 7.14222 16.2934 7.14222 16.1C7.14222 15.9066 6.98606 15.75 6.79331 15.75C5.99351 15.75 5.57695 16.3828 5.57695 17Z" fill="white" stroke="white" stroke-width="0.1"/>
                            <path d="M6.74297 16.1C6.74297 16.2934 6.89913 16.45 7.09188 16.45C7.28463 16.45 7.44079 16.2934 7.44079 16.1V11.9C7.44079 11.7069 7.28467 11.55 7.09188 11.55C6.8991 11.55 6.74297 11.7069 6.74297 11.9V16.1Z" fill="white" stroke="white" stroke-width="0.1"/>
                            <path d="M16.3084 15.8625C16.3084 16.0916 16.4534 16.3 16.6573 16.3C16.8612 16.3 17.0062 16.0916 17.0062 15.8625V11.9875C17.0062 11.7588 16.8612 11.55 16.6573 11.55C16.4534 11.55 16.3084 11.7588 16.3084 11.9875V15.8625Z" fill="white" stroke="white" stroke-width="0.1"/>
                            <path d="M16.3082 11.9C16.3082 12.093 16.4643 12.25 16.6571 12.25C16.8499 12.25 17.006 12.093 17.006 11.9C17.006 9.10804 14.6568 6.74999 11.8745 6.74999C9.09222 6.74999 6.74297 9.10804 6.74297 11.9C6.74297 12.093 6.8991 12.25 7.09188 12.25C7.28467 12.25 7.44079 12.093 7.44079 11.9C7.44079 9.48813 9.47181 7.44999 11.8745 7.44999C14.2772 7.44999 16.3082 9.48813 16.3082 11.9Z" fill="white" stroke="white" stroke-width="0.1"/>
                            <path d="M6.62974 16.45H16.8763C17.1017 16.45 17.3058 16.3038 17.3058 16.1C17.3058 15.8961 17.1017 15.75 16.8763 15.75H6.62974C6.40428 15.75 6.20024 15.8961 6.20024 16.1C6.20024 16.3038 6.40428 16.45 6.62974 16.45Z" fill="white" stroke="white" stroke-width="0.1"/>
                            <path d="M16.6077 17.9C16.6077 18.0934 16.7639 18.25 16.9566 18.25C17.7564 18.25 18.173 17.6172 18.173 17C18.173 16.3828 17.7564 15.75 16.9566 15.75C16.7639 15.75 16.6077 15.9066 16.6077 16.1C16.6077 16.2934 16.7639 16.45 16.9566 16.45C17.1519 16.45 17.2791 16.5243 17.3588 16.6268C17.4399 16.7312 17.4752 16.8695 17.4752 17C17.4752 17.1305 17.4399 17.2687 17.3588 17.3731C17.2791 17.4756 17.1519 17.55 16.9566 17.55C16.7639 17.55 16.6077 17.7066 16.6077 17.9Z" fill="white" stroke="white" stroke-width="0.1"/>
                            <path d="M6.79403 18.25H16.9571C17.1498 18.25 17.306 18.0934 17.306 17.9C17.306 17.7066 17.1498 17.55 16.9571 17.55H6.79403C6.60128 17.55 6.44512 17.7066 6.44512 17.9C6.44512 18.0934 6.60128 18.25 6.79403 18.25Z" fill="white" stroke="white" stroke-width="0.1"/>
                            <path d="M12.7217 7.2749C12.7217 7.46794 12.8778 7.6249 13.0706 7.6249C13.2633 7.6249 13.4195 7.46828 13.4195 7.2749V6.5C13.4195 5.65956 12.7128 4.95 11.8749 4.95C11.0371 4.95 10.3304 5.65956 10.3304 6.5V7.2749C10.3304 7.46794 10.4865 7.6249 10.6793 7.6249C10.8721 7.6249 11.0282 7.46794 11.0282 7.2749V6.5C11.0282 6.03964 11.4167 5.65 11.8749 5.65C12.3332 5.65 12.7217 6.03964 12.7217 6.5V7.2749Z" fill="white" stroke="white" stroke-width="0.1"/>
                            <path d="M9.73271 17.9C9.73271 19.0659 10.7132 20.05 11.8751 20.05C13.037 20.05 14.0175 19.0659 14.0175 17.9C14.0175 17.7066 13.8613 17.55 13.6686 17.55C13.4758 17.55 13.3197 17.7066 13.3197 17.9C13.3197 18.6858 12.6574 19.35 11.8751 19.35C11.0928 19.35 10.4305 18.6858 10.4305 17.9C10.4305 17.7066 10.2744 17.55 10.0816 17.55C9.88888 17.55 9.73271 17.7066 9.73271 17.9Z" fill="white" stroke="white" stroke-width="0.1"/>
                        </svg>
                    </template>
                </div>
                <div class="notifications-item-content">
                    <div class="notifications-item-content-title" :class="{'mb-1': notification.isExpand}">
                        <a :href="notification.item.url ? notification.item.url : '#'">{{notification.item.title}}</a>
                    </div>
                    <div class="notifications-item-content-text" v-if="notification.isExpand"><span v-html="notification.item.data"></span> <a href="/" v-if="notification.item.url">Read more</a></div>
                </div>
                <div class="toggle-btn" @click="notification.isExpand = !notification.isExpand">
                    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.99999 5.11461L10.7151 0.228455C11.009 -0.0761543 11.4856 -0.0761538 11.7795 0.228456C12.0735 0.533065 12.0735 1.02693 11.7795 1.33154L6.58117 6.71852C6.56652 6.73674 6.55095 6.75444 6.53444 6.77154C6.38627 6.92509 6.19169 7.00124 5.99749 6.99998C5.80496 6.99991 5.61245 6.92375 5.46555 6.77153C5.44911 6.75448 5.43358 6.73685 5.41897 6.71869L0.220454 1.33156C-0.0734906 1.02695 -0.0734896 0.53308 0.220455 0.22847C0.514399 -0.076139 0.990977 -0.076139 1.28492 0.22847L5.99999 5.11461Z" fill="#929292"/>
                    </svg>
                </div>
                <div class="close-btn" @click="deleteNotification(notification.item.id)">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="28" height="28" rx="14" fill="white"/>
                        <rect x="8.06561" y="18.9271" width="15.3623" height="1.5173" rx="0.758649" transform="rotate(-45 8.06561 18.9271)" fill="#929292"/>
                        <rect x="8" y="9.07289" width="1.5173" height="15.3623" rx="0.758649" transform="rotate(-45 8 9.07289)" fill="#929292"/>
                    </svg>
                </div>
            </div>
            </template>
        </div>
    </div>
</template>

<script>

export default {
    name: 'GlobalNotification',
    data() {
        return {
            notifications: [],
            deleteNotifications: []
        }
    },
    mounted() {
        let data = JSON.parse(localStorage.getItem('deletedGlobalNotifications'));

        if(data) this.deleteNotifications = data;

        this.getGlobalNotification();
    },
    methods: {
        getGlobalNotification() {
            axios.get('/api/content/block/global_notification').then(response => {
                if(response.data.data) {
                    response.data.data.items.forEach(item => {
                        this.notifications.push({
                            isExpand: false,
                            item
                        });
                    })
                }

            })
        },
        deleteNotification(nId) {
            this.deleteNotifications.push(nId);
            localStorage.setItem('deletedGlobalNotifications', JSON.stringify(this.deleteNotifications));
        }
    }
}
</script>

<style lang="scss" scoped>
#global_notification {
    box-shadow: inset 0 0 8px 0 #d8dbdf;
    position: relative;
    background: rgb(239, 241, 243);

    .notifications {
        &-item {
            display: flex;
            position: relative;
            border-bottom: 1px solid #ffffff;
            padding: 14px 35px 14px 0;

            .toggle-btn {
                width: 28px;
                height: 15px;
                position: absolute;
                right: 100px;
                bottom: 0;
                background: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 5px 5px 0 0;
                box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.05);
                cursor: pointer;

                @media (max-width: 1024px) {
                    right: 50%;
                    margin-right: -14px;
                }

                svg {
                    transition: transform 400ms;
                }
            }

            .close-btn {
                position: absolute;
                right: 0;
                top: 50%;
                margin-top: -14px;
                cursor: pointer;
                transition: 400ms;

                &:hover {
                    transform: rotate(90deg);
                }
            }

            &-image {
                margin-right: 24px;
                width: 45px;
                min-width: 45px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    height: 100%;
                    width: 100%;
                    object-fit: cover;
                    border-radius: 5px;
                }

                svg {
                    width: 25px;
                }
            }

            &-content {
                display: flex;
                align-items: center;

                @media (max-width: 1024px) {
                    width: 100% !important;
                }

                &-title {
                    a {
                        font-size: 15px;
                        line-height: 135%;
                        color: #2E76E4;
                        font-weight: 700;
                    }
                }
            }

            &.show {
                @media (max-width: 1024px) {
                    flex-wrap: wrap;
                }

                .notifications-item-image {
                    width: 114px;
                    min-width: 114px;
                    height: 76px;

                    @media (max-width: 1024px) {
                        width: 100%;
                        height: 150px;
                        margin-bottom: 10px;
                        margin-right: 0;
                    }

                    svg {
                        width: 45px;
                        @media (max-width: 1024px) {
                            width: 100px;
                        }
                    }
                }

                .toggle-btn {
                    svg {
                        transform: rotate(180deg);
                    }
                }

                .close-btn {
                    @media (max-width: 1024px) {
                        top: 15px !important;
                        margin-top: 0;
                    }

                }

                .notifications-item-content {
                    display: block;

                    .notifications-item-content-text {

                    }
                }
            }
        }
    }
}
</style>
